import React from 'react';
import { motion } from 'framer-motion';
import { T, Lang } from '../lib/i18n';
export function Value({
  lang
}: {
  lang: Lang;
}) {
  const t = T[lang].value;
  const features = [t.f1, t.f2, t.f3, t.f4];
  const tableRows = [{
    label: t.t_r1,
    val: '$600'
  }, {
    label: t.t_r2,
    val: '$200'
  }, {
    label: t.t_r3,
    val: '$150'
  }, {
    label: t.t_r4,
    val: '$300'
  }, {
    label: t.t_r5,
    val: '$250'
  }, {
    label: t.t_r6,
    val: '$150'
  }, {
    label: t.t_r7,
    val: '$100'
  }];
  return <section id="valor" className="bg-white py-24 px-4 md:px-8" data-id="element-348">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-349">
        {/* Left */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-350">
          <div className="inline-block bg-brand-blue-primary/10 text-brand-blue-primary text-sm font-bold px-3 py-1 rounded-full mb-4" data-id="element-351">
            {t.tag}
          </div>
          <h2 className="font-display font-extrabold text-3xl md:text-5xl text-brand-navy-dark mb-6 leading-tight" data-id="element-352">
            {t.h2_1}
            <span className="bg-gradient-brand bg-clip-text text-transparent" data-id="element-353">
              {t.h2_2}
            </span>
          </h2>
          <p className="text-brand-text-secondary text-lg mb-10" data-id="element-354">
            {t.subtitle}
          </p>

          <div className="space-y-4" data-id="element-355">
            {features.map((feat, i) => <div key={i} className="bg-white border border-brand-blue-primary/10 rounded-xl p-4 flex items-center space-x-4 transition-all duration-300 hover:border-l-[3px] hover:border-l-brand-blue-primary hover:translate-x-1 shadow-sm hover:shadow-md" data-id="element-356">
                <span className="text-brand-text-primary font-medium" data-id="element-357">
                  {feat}
                </span>
              </div>)}
          </div>
        </motion.div>

        {/* Right */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white border border-brand-blue-primary/10 rounded-2xl overflow-hidden shadow-lg" data-id="element-358">
          <div className="p-6 border-b border-brand-blue-primary/10 bg-brand-bg-subtle/50" data-id="element-359">
            <h3 className="font-display font-bold text-brand-text-muted" data-id="element-360">
              {t.t_head}
            </h3>
          </div>

          <div className="px-6" data-id="element-361">
            {tableRows.map((row, i) => <div key={i} className="flex justify-between py-4 border-b border-brand-blue-primary/5 text-sm" data-id="element-362">
                <span className="text-brand-text-secondary" data-id="element-363">{row.label}</span>
                <span className="text-brand-text-muted" data-id="element-364">{row.val}</span>
              </div>)}
            <div className="flex justify-between py-5 bg-brand-blue-primary/5 -mx-6 px-6 font-bold text-brand-navy-dark" data-id="element-365">
              <span data-id="element-366">{t.t_total}</span>
              <span className="text-brand-blue-primary" data-id="element-367">$2,050</span>
            </div>
          </div>

          <div className="p-6 bg-gradient-to-br from-brand-blue-primary/5 to-brand-gold-champagne/10 border-t border-brand-blue-primary/20 flex items-center justify-between" data-id="element-368">
            <div data-id="element-369">
              <div className="text-brand-blue-primary text-xs font-bold uppercase tracking-wider mb-1" data-id="element-370">
                {t.inv_label}
              </div>
              <div className="text-brand-text-muted text-sm" data-id="element-371">{t.inv_sub}</div>
            </div>
            <div className="font-display font-black text-4xl text-brand-blue-primary" data-id="element-372">
              $800
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}